import React from "react"
import Layout from "../../components/layout/baseLayout"
import SEO from "../../components/seo"

import Typeform from "../../components/Typeform"
export default function ideathon() {
  return (
    <Layout>
      <SEO title="Ideathon"></SEO>
      <Typeform url="https://nassim780857.typeform.com/to/cdfooQ"></Typeform>
    </Layout>
  )
}
